<template>
  <div class="login-container">
    <el-form 
      autoComplete="on" 
      :model="loginForm"  
      size='default' 
      :rules="loginRules" 
      ref="loginForm" 
      class="card-box login-form">
      <h3 class="title">{{$store.state.sys.title}}</h3>
      <el-form-item prop="username">
        <el-input name="username"   type="text" v-model.trim="loginForm.username" autoComplete="on" placeholder="登录用户名" />
      </el-form-item>
      <el-form-item prop="password">
        <el-input name="password"  :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on"
          placeholder="登录密码"></el-input>
      </el-form-item>
      <el-form-item class="btn">
          <el-button class="btn-login" type="primary" :loading="loading" @click.native.prevent="handleLogin">登录</el-button>
      </el-form-item>
    </el-form>
    <div class="foot_copy" v-html="$store.state.sys.company"></div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {      
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', message:'请输入用户名' }],
        password: [{ required: true, trigger: 'blur', message:'请输入密码' }]
      },
      loading: false,
      pwdType: 'password'
    }
  },
  computed:{
  },
  created(){

  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('login', this.loginForm).then((res) => {
            this.$router.push({ path: '/index' })
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
  @dark_gray:#889aa4;
  @light_gray:#eee;
  @active:#409EFF;
  .login-container {
    position: fixed;
    height: 100%;
    width:100%;
    background:url('../assets/home_images/loginbg.jpg') no-repeat;
    background-size: cover;
    left:0;
    top:0;
    right:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      -webkit-appearance: none;
      height: 46px;
    }
    


    .login-form {
      border-radius: 5px;
      background-clip: padding-box;
      width: 350px;
      margin: 0 auto;
      padding: 20px 40px;
      background-color: hsla(0,0%,100%,.9);
      border: 1px solid #eaeaea;
    }
    .title {
      margin: 16px auto 25px;
      text-align: center;
      font-size: 24px;
      color: #505458;
    }
    .btn {
      text-align: center;
    }
    .btn-login {
      width: 100%;
      padding: 15px 20px;
    }
    .foot_copy{
      width:100%;
      height:30px;
      bottom: 10px;
      color: #ccc;
      text-align: center;
      position: absolute;
      z-index: 999;
      left:0;
      font-size:14px;
    }
    .foot_copy a{
      color:#fff;
      font-weight: bold;
      display:inline-block;
      background: @active;
    }
    .el-form-item__content{
      height:auto;
    }
  }
</style>
